'use strict';

import TrackingLayer from '../modules/module.tracking-layer';

function initEventHandlers() {
	 let page = {
        type: "Newsletter", 
        breadcrumb: ["Home", "Newsletter", "Thankyou"]
    };

    TrackingLayer.pushData(page, 'page');
    var user = dataLayer.find(o => o.user != null).user;
    dataLayer.push({
        'event': 'custom_event',
        'eventCategory': 'footer_navigation',
        'eventAction': 'newsletter_signup',
        'eventLabel': 'newsletter_signup success',
        'country': window.GlobalAttributes.COUNTRY,
        'language': window.GlobalAttributes.LANGUAGE,
        'screenName': 'Footer navigation',
        'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
        'userId': user.user_id != '' ? user.user_id : ''
    });
};

exports.init = function () {
    initEventHandlers();
};



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/subscriberconfirmation.js